<template>
  <section class="sku_section sku-suite">
    <div class="section_title">
      <span class="title">套餐</span>
    </div>
    <div class="section_content" role="list" aria-multiselectable="false" aria-label="选择套餐" aria-required="true">
      <div
        class="sku_btn t-c"
        :class="{ 'sku_btn--checked': !currentSuite.id }"
        tabindex="0"
        role="listitem"
        @click="checkSuite({})"
      >
        <span class="name" :aria-label="!currentSuite.id ? '已选中,官方标配' : '未选中,官方标配'">官方标配</span>
      </div>
      <template v-for="(suite, idx) in suites">
        <div
          class="sku_btn sku_btn--suite"
          @click="checkSuite(suite)"
          :class="{ 'sku_btn--checked': currentSuite.id == suite.id }"
          :key="suite.id"
          tabindex="0"
          role="listitem"
        >
          <span class="name" :aria-label="currentSuite.id == suite.id ? ('已选中,' + suite.name) : ('未选中,' + suite.name)">{{ suite.name }}</span>
          <span class="price" :aria-label="`价值${suite.totalPrice}元`">¥{{ suite.totalPrice | formatNumber }}</span>
          <span class="badge" v-if="suite.discountAmount">
            <i class="text fs-30">已省￥{{ suite.discountAmount | formatNumber }}</i>
          </span>
        </div>

        <!-- 套餐详情 -->
        <div
          class="suite-detail"
          :key="'detail-' + suite.id"
          v-if="(idx % 2 == 0 || idx == suites.length - 1) && currentSuite.id"
          v-show="checkedIndex == idx || (idx % 2 == 0 && checkedIndex == idx - 1)"
        >
          <div class="header" tabindex="0">
            <span class="name">{{ currentSuite.name }}</span>
          </div>
          <ul class="bundle_list">
            <li class="bundle_item" tabindex="0">
              <img
                class="bundle-img"
                v-if="(skuInfo.imageInfos || []).length"
                :src="skuInfo.imageInfos[0].smallPic"
                alt=""
              />
              <div class="content">
                <p class="info">
                  <img
                    class="act-tag"
                    v-if="currentSuite.mainSkuActTagCode == 'quickBuy'"
                    :src="require(`@/assets/img/order/quickBuy.png`)"
                  />
                  <span class="name fs-36">{{ skuInfo.commoditySkuBaseInfo.skuName }}</span>
                  <span class="price fs-36" :class="[currentSuite.mainSkuQgPrice ? 'red' : '']">
                    ¥{{ currentSuite.mainSkuQgPrice || skuInfo.commoditySkuBaseInfo.salePrice | formatNumber }}
                  </span>
                </p>
                <p class="color fs-30">{{ skuInfo.commoditySkuBaseInfo.colorName }}</p>
              </div>
            </li>
            <li class="bundle_item" v-for="(bundle, idx) in currentSuite.bundleSkus" :key="idx" tabindex="0">
              <img class="bundle-img" :src="bundle.imgUrl" alt="" />
              <div class="content">
                <p class="info">
                  <img
                    class="act-tag"
                    v-if="bundle.actTagCode == 'quickBuy'"
                    :src="require(`@/assets/img/order/quickBuy.png`)"
                  />
                  <span class="name fs-36">{{ bundle.name }}</span>
                  <span class="price fs-36" :class="[bundle.qgPrice ? 'red' : '']">
                    ¥{{ bundle.qgPrice || bundle.salePrice | formatNumber }}
                  </span>
                </p>
                <p class="color fs-30">{{ bundle.colorName }}</p>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { formatNumber } from 'utils/common'
const { mapGetters } = createNamespacedHelpers('detailv3')
export default {
  name: 'SkuSuite',
  props: {
    skuInfo: Object,
    suites: Array,
    currentSuite: Object,
    trackData: Object
  },
  computed: {
    ...mapGetters('detailv3', ['discountType']),
    checkedIndex() {
      return this.suites.findIndex(suite => suite.id === this.currentSuite.id)
    },
    salePrice() {
      let price = 0
      if (this.skuInfo.commoditySkuDiscount.commodityEstimated) {
        price = this.skuInfo.commoditySkuDiscount.commodityEstimated.commodityEstimatedPrice
      } else if (this.discountType === 'deposit') {
        price = this.skuInfo.commoditySkuBaseInfo.salePrice
      } else {
        price = this.skuInfo.commoditySkuDiscount.commodityDiscountPrice || this.skuInfo.commoditySkuBaseInfo.salePrice
      }
      if (price == 999999) {
        return '待发布'
      } else {
        return formatNumber(price + (this.type == 'popup' ? this.totalAdditionCommodityActivityPrice : 0))
      }
    }
  },
  methods: {
    // 切换套餐
    checkSuite(suite) {
      // 当点击的时当前已选中的套餐时，不做处理
      if (this.currentSuite.id !== suite.id) {
        // 通知父组件套餐更改
        this.$emit('suiteChange', suite)
      }
      // 点击埋点
      let data = this.trackData
      data.button = suite.id || 0
      this.$track(data)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
